import * as Sentry from "@sentry/react";
import { name, version } from "../../package.json"
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const isSentryEnabled = import.meta.env.VITE_SENTRY_ENABLED

if(isSentryEnabled){
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: `${name}@${version}`,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        networkDetailAllowUrls: [/.*/],
        networkRequestHeaders: ["Authorization", "Content-Type", "Cache-Control"],
        networkResponseHeaders: ["Referrer-Policy", "Content-Length"],
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.captureConsoleIntegration({
        levels: ["error"]
      }),
      Sentry.rewriteFramesIntegration({
        iteratee: (frame) => {
          if (frame.filename) {
            frame.filename = frame.filename.replace(/^.*\/dashboard\//, "~/dashboard/");
          }
          if (frame.filename) {
            frame.filename = frame.filename.replace("webpack:///", "/src/").replace(/^.*\/dist\//, "/src/");
          }
          return frame;
        },
      }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [import.meta.env.VITE_APP_URL],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    maxValueLength: 1000000
  });
  console.info("SENTRY INIT")
  
  window.addEventListener('error', function(event) {
    Sentry.captureException(event.error instanceof Error ? event.error : new Error("DOM Exception", {cause:event.error}))
  });
}


export default Sentry